<app-modal>
  <h2>
    {{isCreate ? 'Add Response' : 'Update Response'}}
  </h2>

  <p class="modal-intro mt-0100 mb-0075">
    Responses are the answers that are available for each field. Each
    response is unique and belongs to one field.
  </p>
  <form (ngSubmit)="onSubmit()"
        *ngIf="formGroup"
        [formGroup]="formGroup">
    <app-field-response-form [isAddress]="isAddress"
                             formControlName="fieldResponse">
    </app-field-response-form>

    <div class="alert alert--warning mt-0100 mb-0100" *ngIf="isUniversal">
      <h5 class="alert__heading alert-color">
        <i class="fal fa-triangle-exclamation alert-color mr-0025"></i> Warning
      </h5>
      <div class="alert__content">
        <p class="mb-0">
          <ng-container *ngIf="isCreate">
            You are adding a response to a &#8220;universal field&#8221;. This means that any response added here will become
            immediately available and enabled <strong>across all campaigns</strong> for which the field is enabled.
          </ng-container>
          <ng-container *ngIf="!isCreate">
            You are editing a response to a &#8220;universal field&#8221;. This means that any changes made here will be
            reflected immediately <strong>across all campaigns</strong> for which the field is enabled.
          </ng-container>
        </p>
      </div>
    </div>

    <mat-dialog-actions>
      <button mat-button
              type="submit"
              [disabled]="formGroup.invalid"
              class="btn">Save</button>
    </mat-dialog-actions>
  </form>
</app-modal>
